import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { productColor, productName, clip, tankLabel } from "@/lib/tank";

export { clip };

export const tankPatch = (site, i) => {
  const x = site.tanks[i];
  return { capacity: x.capacity, diameter: x.diameter, ends: x.ends, product: x.product, startInches: x.startInches, activeSiteId: site.id, activeTank: i, activeLabel: x.label, activeEpa: !!x.epaTankId, customDims: false, customLength: 0,
    activeKey: `${x.capacity}-${x.diameter}-${x.ends}`, activeName: clip(`${site.name} · ${tankLabel(x.label) || `Tank ${i + 1}`}`, 80) };
};

export function SiteSwitcher({ s, patch, onTank }) {
  const { user } = useAuth();
  const t = useT();
  const [sites, setSites] = useState([]);

  useEffect(() => {
    if (!user) { setSites([]); return; }
    const load = () => api.getSites().then(setSites).catch(() => {});
    load();
    window.addEventListener("sites-changed", load);
    return () => window.removeEventListener("sites-changed", load);
  }, [user]);

  if (!sites.length) return null;
  const site = sites.find((x) => x.id === s.activeSiteId);
  const pick = (p) => { patch(p); onTank?.(p); };

  return (
    <div className="card site-switch" data-testid="site-switcher">
      <div className="label"><MapPin size={12} /> {t("Station")}</div>
      <div className="chip-row">
        {sites.map((x) => (
          <button key={x.id} type="button" className={`chip ${site?.id === x.id ? "chip-active" : ""}`} data-testid={`switch-site-${x.id}`}
            onClick={() => pick(tankPatch(x, 0))}>{x.name}</button>
        ))}
      </div>
      {site && (
        <div className="chip-row switch-tanks">
          {site.tanks.map((x, i) => (
            <button key={i} type="button" className={`chip ${s.activeTank === i ? "chip-active" : ""}`} data-testid={`switch-tank-${i}`}
              onClick={() => pick(tankPatch(site, i))}>
              <span className="grade-dot" style={{ background: productColor(x.product) }} />{tankLabel(x.label) || t(productName(x.product))}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
